var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 390,
    viewBox: "0 0 425 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117 62H385.046C387.254 62.0333 389.428 62.5669 391.416 63.5633C393.405 64.5598 395.16 65.9953 396.56 67.7695C397.96 69.5437 398.97 71.614 399.521 73.8359C400.071 76.0579 400.149 78.3779 399.748 80.6341L363.877 297",
    stroke: "#CCCCCC",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.206 44.7622H123.408L119.025 62.0676H221.544L219.206 44.7622Z",
    stroke: "#CCCCCC",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M365.15 127.873C366.36 127.613 367.551 127.272 368.716 126.855",
    stroke: "#B7B7B7",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M375.2 123.539C377.508 122.113 379.475 120.199 380.962 117.93C382.449 115.662 383.42 113.094 383.807 110.41C385.22 93.9299 365.15 84.8268 367.223 65.7837C369.2 47.6185 388.254 46.3221 395.892 48.8333C404.328 51.6068 401.438 59.7151 393.799 58.6687C380.557 56.8548 372.233 42.4584 378.523 26.128C381.574 18.7304 387.429 12.841 394.809 9.74689",
    stroke: "#B7B7B7",
    strokeMiterlimit: 10,
    strokeDasharray: "3.93 3.93"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M398.188 8.40338C399.353 7.99089 400.543 7.65527 401.751 7.39871",
    stroke: "#B7B7B7",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M410.182 4.46235C408.826 0.260574 399.746 1.77038 401.519 7.25978C403.291 12.7492 411.539 8.66411 410.182 4.46235Z",
    fill: "#B7B7B7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M396.581 2.76837C396.648 0.925636 399.212 -0.492195 402.836 0.162157C405.357 0.736505 407.745 1.78687 409.872 3.25684C407.644 4.57118 405.185 5.44642 402.627 5.8352C398.965 6.2218 396.513 4.61962 396.581 2.76837Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M400.033 13.7046C401.166 15.1598 404.075 14.8106 406.631 12.1607C408.34 10.2204 409.663 7.97168 410.529 5.53528C407.953 5.77221 405.446 6.5005 403.144 7.68077C399.948 9.50878 398.895 12.2429 400.033 13.7046Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M410.183 4.4625C409.883 4.55929 409.561 4.56502 409.258 4.47895C408.955 4.39288 408.684 4.21889 408.48 3.97897C408.276 3.73905 408.148 3.44399 408.111 3.13108C408.075 2.81818 408.132 2.5015 408.276 2.22108C408.419 1.94066 408.643 1.70909 408.918 1.55567C409.193 1.40225 409.507 1.33386 409.821 1.35915C410.135 1.38444 410.435 1.50228 410.682 1.69776C410.929 1.89323 411.112 2.15758 411.209 2.45735C411.273 2.6564 411.298 2.86616 411.281 3.07465C411.264 3.28314 411.206 3.48629 411.111 3.67248C411.016 3.85868 410.885 4.02428 410.726 4.15983C410.566 4.29538 410.382 4.39823 410.183 4.4625Z",
    fill: "#B7B7B7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M411.161 7.49392C410.862 7.59071 410.54 7.59645 410.237 7.51038C409.934 7.42432 409.663 7.25032 409.459 7.0104C409.255 6.77049 409.126 6.47541 409.09 6.1625C409.053 5.8496 409.11 5.53292 409.254 5.2525C409.398 4.97208 409.621 4.74051 409.896 4.58709C410.171 4.43367 410.486 4.36529 410.8 4.39058C411.114 4.41587 411.413 4.53371 411.66 4.72919C411.907 4.92467 412.091 5.18901 412.188 5.48879C412.252 5.68784 412.276 5.8976 412.26 6.10609C412.243 6.31458 412.185 6.51773 412.09 6.70392C411.994 6.89011 411.863 7.0557 411.704 7.19125C411.545 7.3268 411.36 7.42965 411.161 7.49392Z",
    fill: "#B7B7B7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M212.5 389.28C329.861 389.28 425 378.855 425 365.996C425 353.136 329.861 342.711 212.5 342.711C95.1395 342.711 0 353.136 0 365.996C0 378.855 95.1395 389.28 212.5 389.28Z",
    fill: "#EFEFEF"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114 80L122 50",
    stroke: "#CCCCCC",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M348.698 311.104H86.4205C82.8359 311.104 79.3654 309.845 76.6153 307.545C73.8652 305.246 72.0105 302.054 71.3754 298.526L35.2318 97.7767C34.8354 95.5752 34.927 93.3135 35.5001 91.1513C36.0732 88.989 37.1139 86.9789 38.5487 85.2628C39.9835 83.5466 41.7774 82.1663 43.8038 81.2191C45.8303 80.2719 48.0399 79.781 50.2768 79.781H312.554C316.138 79.781 319.609 81.0406 322.359 83.3398C325.109 85.6389 326.964 88.8314 327.599 92.3592L363.743 293.108C364.139 295.31 364.047 297.572 363.474 299.734C362.901 301.896 361.861 303.906 360.426 305.622C358.991 307.338 357.197 308.719 355.171 309.666C353.144 310.613 350.934 311.104 348.698 311.104V311.104Z",
    stroke: "#DBDBDB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9725 59.8614V53.762",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7625 61.6572L59.7129 56.3751",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2824 66.3176L53.0002 63.2679",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7324 72.5937H50.6332",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7051 72.1014H87.8044",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9089 65.8912L85.1911 62.8416",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2489 61.411L78.2985 56.1288",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M143.936 195.971C149.328 195.971 153.699 191.6 153.699 186.209C153.699 180.817 149.328 176.446 143.936 176.446C138.544 176.446 134.174 180.817 134.174 186.209C134.174 191.6 138.544 195.971 143.936 195.971Z",
    fill: "#B7B7B7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M243.643 195.971C249.035 195.971 253.406 191.6 253.406 186.209C253.406 180.817 249.035 176.446 243.643 176.446C238.251 176.446 233.88 180.817 233.88 186.209C233.88 191.6 238.251 195.971 243.643 195.971Z",
    fill: "#B7B7B7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M182.828 236.199C182.828 236.199 186.334 231.376 196.557 231.376C201.564 231.286 206.436 232.998 210.286 236.199",
    stroke: "#B7B7B7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.d4c183bf223b848ce3ccb6ae65f62b0d.svg";
export { ForwardRef as ReactComponent };